import { t } from '../../i18n';

// Laden ist fehlgeschlagen (z. B. Serverfehler): Hinweis mit „Erneut versuchen“ statt endlosem Laden.
export function LoadError({ onRetry }: { onRetry(): void }) {
  return (
    <div className="chat-err" role="alert">
      <p className="muted">{t('Nachrichten konnten nicht geladen werden.')}</p>
      <button type="button" className="btn2" onClick={onRetry}>
        {t('Erneut versuchen')}
      </button>
    </div>
  );
}
